var _style, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHxCo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bandera",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.4 453.2",
    style: {
      enableBackground: "new 0 0 511.4 453.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000175298535144138548970000017013435250987487400_);fill:#F3D02F;}\n\t.st1{clip-path:url(#SVGID_00000175298535144138548970000017013435250987487400_);fill:#273B8C;}\n\t.st2{clip-path:url(#SVGID_00000175298535144138548970000017013435250987487400_);fill:#BC1F34;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.4,0H149c-15.1,0-29.1,8.1-36.7,21.2L5.7,205.4c-7.6,13.1-7.6,29.4,0,42.5L112.3,432c7.6,13.1,21.6,21.2,36.7,21.2 h213.4c15.1,0,29.1-8.1,36.7-21.2l106.6-184.2c7.6-13.1,7.6-29.4,0-42.5L399.1,21.2C391.5,8.1,377.5,0,362.4,0L362.4,0z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M118.3,432.8L8.4,242.5c-5.7-9.8-5.7-22,0-31.8L118.3,20.4c5.7-9.8,16.2-15.9,27.5-15.9h219.7 c11.4,0,21.9,6.1,27.5,15.9L503,210.7c5.7,9.8,5.7,22,0,31.8L393.1,432.8c-5.7,9.8-16.2,15.9-27.5,15.9H145.9 C134.5,448.7,124,442.7,118.3,432.8L118.3,432.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168099684873791696020000001058458374478582188_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000168099684873791696020000001058458374478582188_)",
      fill: "#F3D02F"
    },
    width: 511.4,
    height: 226.6
  }), /*#__PURE__*/React.createElement("rect", {
    y: 226.6,
    style: {
      clipPath: "url(#SVGID_00000168099684873791696020000001058458374478582188_)",
      fill: "#273B8C"
    },
    width: 511.4,
    height: 111
  }), /*#__PURE__*/React.createElement("rect", {
    y: 337.7,
    style: {
      clipPath: "url(#SVGID_00000168099684873791696020000001058458374478582188_)",
      fill: "#BC1F34"
    },
    width: 511.4,
    height: 115.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHxCo);
export default __webpack_public_path__ + "static/media/hx-co.def71701a198f562d4452c759b3b4698.svg";
export { ForwardRef as ReactComponent };